import { NormalBrowseFileInputFiled, NormalTextInputField } from "@/components";
import React, { useMemo } from "react";

const CommonBannerHeroSection = ({
  activeLang,
  isFetching,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  handleTextInputChange,
  stateDetails,
  adminRole,
  permissionsList,
  imageInputFieldLabel = "",
  imageInputFieldKeyName = "",
  imageInputFieldInfoText = "Recommended size: 1300 x 650px",

  headingInputFieldLabel = "",
  headingInputFieldKeyName = "",

  subHeadingInputFieldLabel = "",
  subHeadingInputFieldKeyName = "",
}) => {
  const isNonTranslatableField = useMemo(() => {
    return activeLang === "en" ? true : false;
  }, [activeLang]);

  const getSelectedBannerImageId = (id) => {
    if (id) {
      onChangeImage(imageInputFieldKeyName, id);
    } else {
      onChangeImage(imageInputFieldKeyName, "");
    }
  };

  return (
    <>
      {/* Banner Image */}
      {isNonTranslatableField && (
        <NormalBrowseFileInputFiled
          isFetching={isFetching}
          labelText={imageInputFieldLabel}
          fieldId={imageInputFieldKeyName}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImageFunction={getSelectedBannerImageId}
          selectedFileId={stateDetails?.[imageInputFieldKeyName] || ""}
          adminRole={adminRole}
          permissionsList={permissionsList}
          infoText={imageInputFieldInfoText}
          extraContainerClasses="mb-5"
        />
      )}

      {/* Banner Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText={headingInputFieldLabel}
        fieldId={headingInputFieldKeyName}
        fieldName={headingInputFieldKeyName}
        placeholderText={headingInputFieldLabel}
        inputValue={stateDetails?.[headingInputFieldKeyName] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      />

      {/* Banner Sub Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText={subHeadingInputFieldLabel}
        fieldId={subHeadingInputFieldKeyName}
        fieldName={subHeadingInputFieldKeyName}
        placeholderText={subHeadingInputFieldLabel}
        inputValue={stateDetails?.[subHeadingInputFieldKeyName] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      />
    </>
  );
};

export default CommonBannerHeroSection;
